import { Component } from "react";
import Loader from "../../../utils/Loader";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import Modal from "react-modal";
import { useNavigate, Link } from "react-router-dom";
// import Footer from '../../common_components/Footer';
import VisitorHeader from '../../../common_components/visitor_module_header';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo"
import { getDelegatePreviewDetails_action, delegatePreviewSubmit_action, delegateConfirmation_action, getDelegateFirldList_action } from "../../../actions/delegate_module_action/delegate_registration_action/delegate_registration_action";
import {
    clearSessionStorage, countryActionId, DOC_BASE_URL,
    stateActionId, cityActionId, pincodeActionId, exhibitionStatusActionId, countryIWithCodeActionId, verifyPrimaryEmailIDActionId, primaryChapterListActionId, onlinePresenceListActionId, notApplicableCountryActionId, noApplicableStateActionId, BASE_URL,
    toastError, toastSuccess
} from '../../../utils/constants'
class DelegateConfirmation extends Component {
    // Intialized Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            geturl: "",
            is_partner: false,
            exhibitionAdd: '',
            exhibitionName: '',
            ExhRegistrationNo: '',
            fromDate: '',
            toDate: '',

            isClickValidation: false,
            scripts: [],
            QRList: [],
            isBadgeSend: false,
            VisitorRegistrationNoArr: [],
            dateToShow: '',

            exhID: '',
        }
        this.getFillList = this.getFillList.bind(this)

    }

    // componentWillUnmount() {
    //     const { isClickValidation } = this.state
    //     if (!isClickValidation) {
    //         sessionStorage.clear()
    //         window.location.replace('http://localhost:3000/#/');
    //     }
    // }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === countryIWithCodeActionId) {
                            console.log("country data", data.data[0]['ExhibitionID'])
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []
                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", moment(data.data[0]['ExhibitionDateFrom']).format("DD/MM/YYYY"))
                            sessionStorage.setItem("exhibitionDateTo", moment(data.data[0]['ExhibitionDateTo']).format("DD/MM/YYYY"))
                            sessionStorage.setItem("ExhibitionCountryID", data.data[0]['ExhibitionCountryID'])
                            sessionStorage.setItem("sessionLogoPath", `${DOC_BASE_URL}${data.data[0]['Logo']}`)

                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])
                            sessionStorage.setItem("isVisitorB2B", data.data[0]['isVisitorB2B'])
                            sessionStorage.setItem("isVisitorSeminar", data.data[0]['isVisitorSeminar'])
                            sessionStorage.setItem("isVisitorRegistrationOpen", data.data[0]['isVisitorRegistrationOpen'])

                            sessionStorage.setItem("ExhVisitorVisaIssueDate", data.data[0]['ExhVisitorVisaIssueDate'])
                            sessionStorage.setItem('DATALOADEDIncomp', true)
                            this.setState({
                                isDataLoad: true,
                                // DATALOADEDIncomp: true,
                                bannerPath: data.data[0]['Banner'] != null && data.data[0]['Banner'],
                                isExibitionClosed: data.data[0]['IsExhibitionClosed'] != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                isregistrationLinkClosed: data.data[0]['isregistrationLinkClosed'] != null && data.data[0]['isregistrationLinkClosed'] == 1 ? true : false,
                            })
                            setTimeout(() => {

                            }, 500);

                            // this.getFillList(countryActionId, data.data[0]['ExhibitionID'], '', '', '', '')
                            resolve(true)
                        }

                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    handleConfirm() {
        // e.preventDefault()
        const { isOpen } = this.state
        this.setState({ isLoading: true })
        this.props.delegateConfirmation_action()
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Participation Confirmed")
                    this.setState({ isLoading: false, isOpen: !isOpen, passportFile: "", passPortFileName: "", isPassportFilePresent: false })
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }



    componentDidMount() {
        var exhCode = ""
        var code = ""
        console.log('lll')
        if (this.props.location != null && this.props.location.state == null) {
            var url = this.props.location.pathname != null && this.props.location.pathname.split("/")
            code = url[url.length - 1]
            console.log()
            this.getFillList(countryIWithCodeActionId, '', '', '', code.split('&')[0], '').then(async () => {
                this.handleConfirm(code.split('&')[1])
            })
        }
    }

    render() {
        const { isLoading, exhibitionAdd, exhibitionName, fromDate, dateToShow, toDate } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}
                {/* {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && <HeaderWithLogo />} */}
                {/* {console.log(!isLinkOpen)} */}
                {/* <div className={'main-content app-content with-dr-container'}> */}
                <VisitorHeader />
                {/* <!-- CONTAINER --> */}
                <div
                    className="main-content app-content mt-0"
                    style={{ backgroundColor: "#ececec", height: '100vh' }}
                >
                    <div className="side-app">
                        <div className="main-container container-fluid top-form-name">
                            <div className="row ">
                                <form className="needs-validation " noValidate="">
                                    <div className="form-row mt-4">
                                        <div className="form-group col-md-7 p-4 thank-box">
                                            <div className="form-group mb-2">
                                                <h4
                                                    className="mb-0 pt-2 pb-4 thank-top-mes"
                                                    style={{ color: "#318958" }}
                                                >
                                                    <strong>Thank You for Confirming Your Attendance</strong>
                                                </h4>
                                                <p className="mb-1 mt-1 text-center com-font">
                                                    We are delighted to confirm your participation.
                                                </p>
                                                <br></br>
                                                <p className="mt-1 mb-0 text-center com-font">

                                                    Your E-Badge will be available for download from 20th November 2026 onwards.
                                                </p>
                                                <p className="mb-3 text-center com-font">
                                                    You can download it from your dashboard after logging in to the India ITME 2026 Portal.
                                                </p>
                                                <br></br>
                                                <p className="mb-3 text-center com-font">
                                                    We look forward to welcoming you to India ITME 2026.
                                                </p>
                                            </div>
                                            {/* <div classname="">
                                                <div classname="mt-1 mb-4">

                                                    <button
                                                        classname="btn btn-aqua"
                                                        style={{
                                                            background: "#007bff",
                                                            padding: "6px 20px",
                                                            fontSize: 14,
                                                            border: "1px solid #007bff",
                                                            borderRadius: 2,
                                                            color: "#fff",
                                                            marginTop: 16
                                                        }}
                                                        onClick={e => this.onPreviousClick(e)}
                                                    >
                                                        {" "}
                                                        BACK TO EVENT WEBSITE
                                                    </button>

                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <Footer /> */}
                {/* <!-- CONTAINER END --> */}

            </>
        );
    }
}


export default withRouter(connect(null, {
    fill_action, getDelegateFirldList_action, getDelegatePreviewDetails_action, delegatePreviewSubmit_action, delegateConfirmation_action
})(DelegateConfirmation))